import type { KpiValue } from '../lib/api.js';
import { deltaTone, fmtDeltaPct } from '../lib/format.js';

interface Props {
  label: string;
  kpi: KpiValue | undefined;
  format: (v: number | null | undefined) => string;
  /** Nota de procedencia del dato (p. ej. Diamond servido del libro mensual). */
  hint?: string;
}

export function KpiCard({ label, kpi, format, hint }: Props) {
  const tone = deltaTone(kpi?.deltaPct);
  const toneClass =
    tone === 'up' ? 'text-emerald-400' : tone === 'down' ? 'text-rose-400' : 'text-slate-400';
  const arrow = tone === 'up' ? '▲' : tone === 'down' ? '▼' : '→';
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-800/60 p-4 shadow-sm">
      <div className="text-xs uppercase tracking-wide text-slate-400">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-slate-50">{format(kpi?.value)}</div>
      {kpi?.deltaPct != null && (
        <div className={`mt-1 text-sm ${toneClass}`}>
          {arrow} {fmtDeltaPct(kpi.deltaPct)} <span className="text-slate-500">vs año previo</span>
        </div>
      )}
      {hint && <div className="mt-1 text-[11px] leading-tight text-slate-500">{hint}</div>}
    </div>
  );
}
